module.exports = __webpack_public_path__ + "img/payu_box.45a3a8db.png";